<div class="flex flex-col min-h-screen -mt-1">
    <app-header></app-header>
    <div class="mb-auto">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
    <app-scroll-top></app-scroll-top>
</div>